import { getCookieDomain } from '@/utils/cookie'

export default defineNuxtPlugin((nuxtApp) => {
  const apolloToken = useCookie<string | null>('apollo-token', {
    path: '/',
    domain: getCookieDomain()
  })

  nuxtApp.hook('apollo:auth', ({ token }) => {
    if (apolloToken.value) {
      token.value = `Bearer ${apolloToken.value}`
    }
  })
})
